const STAGE = process.env.VUE_APP_STAGE || 'dev';

export const DISMISS_AFTER = 6000;

export const mapCognitoLoggedUser = (user) => ({
  username: user['cognito:username'],
  phone: user.phone_number,
  firstName: user.given_name,
  lastName: user.family_name,
  sub: user.sub,
  email: user.email,
  groupName: (user['custom:groupName'] || ''),
  groups: ((user["custom:groups"]) || []),
  role: (user["custom:role"] || ''),
  jwtToken: user.jwtToken,
  iss: user.iss
});

export function buildPaths(params) {
  let result = [];
  let tree = { result };
  params.forEach(el_path => {
    let el_properties = el_path;
    let lock = el_path.locked;
    if (el_path.path) {
      el_path.path.split('/').reduce((r, name, index, arr) => {
        if (!r[name]) {
          r[name] = {
            result: []
          };
          let masterPath = '';
          for (let i = 0; i < index; i++) {
            masterPath = ((i === 0) ? arr[i] : masterPath + '/' + arr[i]);
            masterPath = ((i === index - 1) ? masterPath + '/' : masterPath);
          }
          const isFile = ((index == arr.length - 1) && (name.includes('.')));

          let tmp = el_path.path.split('/');
          if (tmp[tmp.length - 1] === "") { tmp.pop() }
          let splitted_name = isFile ? name.split('.') : undefined;
          if (name) {
            r.result.push({
              name,
              masterPath,
              ...(tmp[tmp.length - 1] === name ? { locked: lock } : false),
              ...(isFile ? { file: splitted_name[splitted_name.length - 1] } : undefined),
              ...(!isFile ? { children: r[name].result } : undefined),
              selected: false,
              el_properties
            });
          }
        }
        return r[name];
      }, tree)
    }
  });
  return result;
}

export { STAGE };
